import { FC } from 'react'
import { Field, Form, Formik } from 'formik'
import * as Yup from 'yup'
import { observer } from 'mobx-react'
import { useTranslation } from 'next-i18next'
import { useRouter } from 'next/router'
import styles from './index.module.scss'
import { getQueryValue, useStores } from '../../../utils'
import { TextAreaGroup } from '../TextAreaGroup'
import { SettingButton } from '../../atoms/SettingButton'
import { IAnswerBase, MessageType } from '../../../types'

type Props = {
  answers: IAnswerBase[]
  setAnswers: (answers: IAnswerBase[]) => void
}

type Value = {
  body: string
}

export const AddAnswerForm: FC<Props> = observer(({ answers, setAnswers }) => {
  const { t } = useTranslation(['p', 'validation'])
  const { messages, viewer } = useStores()
  const router = useRouter()
  const slug = getQueryValue('question_slug', router)
  const initialValue: Value = {
    body: '',
  }

  const validationSchema = Yup.object().shape({
    body: Yup.string().required(t('validation:必須項目です')),
  })

  return (
    <div className={styles.container}>
      <Formik
        initialValues={initialValue}
        validationSchema={validationSchema}
        onSubmit={async (values: Value, actions) => {
          const output = await viewer.viewer?.addMyAnswer(slug, values.body)
          actions.setSubmitting(false)
          if (output.isSuccessful) {
            setAnswers(answers.concat(output.data.answer))
            messages.add({
              type: MessageType.Info,
              body: 'Your reply posted.',
              isTranslated: true,
              ttl: 5000,
            })
          }
          actions.resetForm()
        }}
      >
        {({ isSubmitting }) => {
          return (
            <Form>
              <div className={styles.textarea}>
                <Field
                  name='body'
                  placeholder='Leave your reply'
                  fieldType='setting'
                  isSmall
                  component={TextAreaGroup}
                />
              </div>
              <div className={styles.buttonContainer}>
                <SettingButton
                  isLoading={isSubmitting}
                  disabled={isSubmitting}
                  color='aqa'
                  buttonType='submit'
                  buttonSize='medium'
                >
                  Reply
                </SettingButton>
              </div>
            </Form>
          )
        }}
      </Formik>
    </div>
  )
})
